import { useState } from 'react';
import type { SelectableFile } from '~/components/browser/implementations/FileChooser';
import { FileChooser } from '~/components/browser/implementations/FileChooser';
import { useProjectId } from '~/hooks/context/useProjectId';
import type { SelectedFile } from '../converters';

export default function UploadPart({
  files,
  toggleEditing,
  updateFunc,
}: {
  files: SelectedFile[];
  toggleEditing: (editing: boolean) => void;
  updateFunc: (action: SelectableFile[]) => Promise<void>;
}) {
  const [editing, setEditing] = useState(false);
  const projectId = useProjectId();

  return (
    <div>
      Upload files{' '}
      {files.map((file: { id: string; name: string }, index: number) => (
        <>
          <span
            onClick={() => {
              setEditing(!editing);
              toggleEditing(!editing);
            }}
            className="text-orange-800 dark:text-orange-400"
          >
            {file.name}
          </span>
          {index < files.length - 1 ? ', ' : ''}
        </>
      ))}
      <FileChooser
        open={editing}
        onClose={() => {
          setEditing(false);
          toggleEditing(false);
        }}
        onFileSelect={async (files) => {
          setEditing(false);
          toggleEditing(false);
          await updateFunc(files);
        }}
        projectId={projectId!}
      />
    </div>
  );
}
